module.exports = __webpack_public_path__ + "18a974d4609cd913fe351472fd526642.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannerLogin.png
// module id = 378
// module chunks = 0